import React from 'react';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import { useFeature } from '@growthbook/growthbook-react';
// mui
import { ButtonBase as MuiButtonBase } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
// utils
import {
  convertDateUTC,
  useDetermineEndorsementRestrictions,
  utcToNativeDate,
} from '../../../../utils/date.utils';
import { hasPolicyExpired } from '../../../../utils/hamburgerMenus/options.utils';
import { FEATURE_FLAG_KEYS } from '../../../../config/growthbook';

export const EndorsementDateForPrime250 = ({
  updateDate,
  currentDate,
  latestPolicyDetails,
  originalPolicyDetails,
}: any) => {
  const classes = usePickerClasses();
  const isStartDateFreeSelection = useFeature(
    FEATURE_FLAG_KEYS.IS_START_DATE_FREE_SELECTION
  );

  const { policyEffectiveDateUTC, policyEndDateUTC } = React.useMemo(() => {
    return {
      policyEffectiveDateUTC: convertDateUTC(
        originalPolicyDetails?.effectiveDate ?? Moment().subtract(1, 'y'),
        'UTC'
      ),
      policyEndDateUTC: convertDateUTC(latestPolicyDetails?.endDate, 'UTC'),
    };
  }, [originalPolicyDetails?.effectiveDate, latestPolicyDetails?.endDate]);

  if (hasPolicyExpired(latestPolicyDetails?.status)) {
    return <EndorsementDateForExpiredPrime250 currentDate={policyEndDateUTC} />;
  }

  return (
    <span className={`${classes.paddingStyle} flex--spaced`}>
      <DatePicker
        {...(isStartDateFreeSelection.off && {
          minDate: policyEffectiveDateUTC,
          maxDate: policyEndDateUTC,
        })}
        customInput={<DateToggle />}
        id="endorsementEffectiveDate"
        selected={utcToNativeDate(new Date(currentDate))}
        onChange={updateDate}
      />
    </span>
  );
};

export const EndorsementDateForPrime100 = ({
  updateDate,
  currentDate,
  policyDetails,
}: any) => {
  const classes = usePickerClasses();
  const endorsementDates = useDetermineEndorsementRestrictions(
    policyDetails.effectiveDate,
    policyDetails.endDate
  );

  return (
    <span className={`${classes.paddingStyle} flex--spaced`}>
      <DatePicker
        minDate={endorsementDates.minEndorsementStartDate}
        maxDate={endorsementDates.maxEndorsementEndDate}
        customInput={<DateToggle />}
        id="endorsementEffectiveDate"
        selected={utcToNativeDate(new Date(currentDate))}
        onChange={updateDate}
      />
    </span>
  );
};

export const EndorsementDateForExpiredPrime250 = ({ currentDate }: any) => {
  const classes = usePickerClasses();

  return (
    <span className={`${classes.paddingStyle} flex--spaced`}>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <DatePicker
        customInput={<DateToggle />}
        id="endorsementEffectiveDate"
        selected={utcToNativeDate(new Date(currentDate))}
        disabled
      />
    </span>
  );
};

// @ts-expect-error TS(2339): Property 'value' does not exist on type '{}'.
const DateToggle = React.forwardRef(({ value, onClick }, ref) => {
  const classes = useDateClasses();
  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <MuiButtonBase className={classes.baseStyle} onClick={onClick} ref={ref}>
      {value}
      <ArrowDropDownIcon className={classes.arrowStyle} />
    </MuiButtonBase>
  );
});

const useDateClasses = makeStyles(({ config }) => ({
  arrowStyle: {
    fontSize: config.textSizes.paragon,
  },
  baseStyle: {
    backgroundColor: 'inherit',
    fontSize: config.textSizes.paragon,
    fontWeight: config.weights.bold,
    color: config.colors.cowbellLight,
    lineHeight: 1.4,
  },
}));

const usePickerClasses = makeStyles(() => ({
  paddingStyle: {
    paddingLeft: '0.625rem',
  },
}));
